/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateLeadInfoRequest } from './CreateLeadInfoRequest';
import {
    CreateLeadInfoRequestFromJSON,
    CreateLeadInfoRequestFromJSONTyped,
    CreateLeadInfoRequestToJSON,
    CreateLeadInfoRequestToJSONTyped,
} from './CreateLeadInfoRequest';

/**
 * 
 * @export
 * @interface CreateLeadInfo201Response
 */
export interface CreateLeadInfo201Response {
    /**
     * 
     */
    data?: CreateLeadInfoRequest;
}

/**
 * Check if a given object implements the CreateLeadInfo201Response interface.
 */
export function instanceOfCreateLeadInfo201Response(value: object): value is CreateLeadInfo201Response {
    return true;
}

export function CreateLeadInfo201ResponseFromJSON(json: any): CreateLeadInfo201Response {
    return CreateLeadInfo201ResponseFromJSONTyped(json, false);
}

export function CreateLeadInfo201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeadInfo201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : CreateLeadInfoRequestFromJSON(json['data']),
    };
}

export function CreateLeadInfo201ResponseToJSON(json: any): CreateLeadInfo201Response {
    return CreateLeadInfo201ResponseToJSONTyped(json, false);
}

export function CreateLeadInfo201ResponseToJSONTyped(value?: CreateLeadInfo201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CreateLeadInfoRequestToJSON(value['data']),
    };
}

